import {Bundle} from "../../services/translationProvider";
import {Entity} from "../../utils/types";
import {AgentAvatar} from "./AgentAvatar";

export function AgentInfo(props: { name: string }) {
	let name = props.name;
	if (!name) {
		name = Bundle.t("VCC_XMSG_ALIAS_UNKNOWN");
	}

	return (
		<div className="w-100 d-inline-flex">
			<AgentAvatar name={name} width="30px" height="30px" entity={!props.name ? Entity.unknown : Entity.agent}/>
			<p className="text-light pl-2 my-auto">{name}</p>
		</div>
	);
}
